import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { getMaterialList } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.materialList = [];
    _this.currentIndex = -1;
    // 材质
    _this.materialName = '';
    // 材质id
    _this.materialId = '';
    // 分类id
    _this.classifyId = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.InsteadList();
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      if (to.name === 'consumables') {
        this.$vnode.parent.componentInstance.cache = {};
        this.$vnode.parent.componentInstance.keys = [];
      }
      next(true);
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.$router.push('/user');
    }
    // 材质详情
  }, {
    key: "goDetails",
    value: function goDetails(id) {
      this.$router.push("/consumables-details?id=".concat(id, "&type=1"));
    }
  }, {
    key: "next",
    value: function next() {
      if (this.materialId === '') {
        this.$message.error('请选择材质！');
      } else {
        this.$router.push("/erial-product?materialName=".concat(this.materialName, "&materialId=").concat(this.materialId));
      }
    }
  }, {
    key: "selectMaterial",
    value: function selectMaterial(index, id, name, classifyId) {
      this.currentIndex = index;
      this.materialId = id;
      this.materialName = name;
      this.classifyId = classifyId;
    }
  }, {
    key: "InsteadList",
    value: function () {
      var _InsteadList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getMaterialList({
                pageNo: 1,
                pageSize: 20,
                companyId: 1
              });
            case 2:
              res = _context.sent;
              this.materialList = res.data.data.list;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function InsteadList() {
        return _InsteadList.apply(this, arguments);
      }
      return InsteadList;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;